export default __webpack_public_path__ + "media/icons/home-icon-active-31c47843.svg";